// utils/rbac.js - Role-Based Access Control Configuration

export const TEAM_PERMISSIONS = {
  // telemarketing: {
  //   member: {
  //     allowedRoutes: [
  //       "/dashboard",
  //       "/my-leads",
  //       "/appointments",
  //       "/opportunities",
  //       "/contacts",
  //       "/leads/:id",
  //       "/opportunities/:id",
  //       "/accounts/:id",
  //       "/appointment-data",
  //       "/team-calendar",
  //     ],
  //     navigationItems: [
  //       "Dashboard",
  //       "My Leads",
  //       "Appointments",
  //       "Opportunities",
  //       "Contacts",
  //     ],
  //   },
  //   manager: {
  //     allowedRoutes: [
  //       "/dashboard",
  //       "/leads",
  //       "/my-leads",
  //       "/appointments",
  //       "/opportunities",
  //       "/contacts",
  //       "/accounts",
  //       "/leads/:id",
  //       "/opportunities/:id",
  //       "/accounts/:id",
  //       "/appointment-data",
  //       "/team-calendar",
  //       "/analytics",
  //       "/users",
  //     ],
  //     navigationItems: [
  //       "Dashboard",
  //       "Leads",
  //       "Appointments",
  //       "Opportunities",
  //       "Contacts",
  //       "Accounts",
  //       "Users & Teams",
  //     ],
  //   },
  // },
  telemarketing: {
    member: {
      allowedRoutes: "*", // All routes
      navigationItems: "*", // All navigation items
    },
    manager: {
      allowedRoutes: "*",
      navigationItems: "*",
    },
  },
  management: {
    member: {
      allowedRoutes: "*", // All routes
      navigationItems: "*", // All navigation items
    },
    manager: {
      allowedRoutes: "*",
      navigationItems: "*",
    },
  },
  engineering: {
    member: {
      allowedRoutes: "*", // All routes
      navigationItems: "*", // All navigation items
    },
    manager: {
      allowedRoutes: "*",
      navigationItems: "*",
    },
  },
  sales_engagement: {
    member: {
      allowedRoutes: "*", // All routes
      navigationItems: "*", // All navigation items
    },
    manager: {
      allowedRoutes: "*",
      navigationItems: "*",
    },
  },
  support: {
    member: {
      allowedRoutes: "*", // All routes
      navigationItems: "*", // All navigation items
    },
    manager: {
      allowedRoutes: "*",
      navigationItems: "*",
    },
  },
  operations: {
    member: {
      allowedRoutes: "*", // All routes
      navigationItems: "*", // All navigation items
    },
    manager: {
      allowedRoutes: "*",
      navigationItems: "*",
    },
  },
  sales: {
    member: {
      allowedRoutes: "*", // All routes
      navigationItems: "*", // All navigation items
    },
    manager: {
      allowedRoutes: "*",
      navigationItems: "*",
    },
  },
  // sales: {
  //   member: {
  //     allowedRoutes: [
  //       "/dashboard",
  //       "/appointments",
  //       "/visits",
  //       "/cases",
  //       "/accounts",
  //       "/opportunities",
  //       "/visits/:id",
  //       "/cases/:id",
  //       "/accounts/:id",
  //       "/opportunities/:id",
  //       "/appointment-data",
  //       "/team-calendar",
  //       "/leads",
  //       "/my-leads",
  //       "/leads/:id",
  //       "/engagements",
  //       "/settings/emails",
  //       "/my-opportunities",
  //     ],
  //     navigationItems: [
  //       "Dashboard",
  //       "My Leads",
  //       "Appointments",
  //       "Visits",
  //       "Cases",
  //       "Accounts",
  //       "Opportunities",
  //     ],
  //   },
  //   manager: {
  //     allowedRoutes: [
  //       "/dashboard",
  //       "/appointments",
  //       "/visits",
  //       "/cases",
  //       "/accounts",
  //       "/opportunities",
  //       "/contacts",
  //       "/visits/:id",
  //       "/cases/:id",
  //       "/accounts/:id",
  //       "/opportunities/:id",
  //       "/appointment-data",
  //       "/team-calendar",
  //       "/analytics",
  //       "/users",
  //       "/leads",
  //       "/my-leads",
  //       "/leads/:id",
  //       "/engagements",
  //       "/settings/emails",
  //       "/my-opportunities",
  //     ],
  //     navigationItems: [
  //       "Dashboard",
  //       "Leads",
  //       "My Leads",
  //       "Appointments",
  //       "Visits",
  //       "Cases",
  //       "Accounts",
  //       "Opportunities",
  //       "Contacts",
  //       "Users & Teams",
  //     ],
  //   },
  // },

  // operations: {
  //   member: {
  //     allowedRoutes: [
  //       "/dashboard",
  //       "/installations",
  //       "/tickets",
  //       "/tasks",
  //       "/cases",
  //       "/cases/:id",
  //       "/accounts/:id",
  //       "/projects",
  //       "/projects/:id",
  //       "/project-templates",
  //       "/project-templates/:id",
  //       "/project-tasks/:id",
  //       "/products",
  //     ],
  //     navigationItems: [
  //       "Dashboard",
  //       "Installations",
  //       "Tickets",
  //       "Tasks",
  //       "Cases",
  //     ],
  //   },
  //   manager: {
  //     allowedRoutes: [
  //       "/dashboard",
  //       "/installations",
  //       "/tickets",
  //       "/tasks",
  //       "/cases",
  //       "/accounts",
  //       "/cases/:id",
  //       "/accounts/:id",
  //       "/projects",
  //       "/projects/:id",
  //       "/project-templates",
  //       "/project-templates/:id",
  //       "/project-tasks/:id",
  //       "/products",
  //       "/analytics",
  //     ],
  //     navigationItems: [
  //       "Dashboard",
  //       "Installations",
  //       "Tickets",
  //       "Tasks",
  //       "Cases",
  //       "Accounts",
  //     ],
  //   },
  // },
};

/**
 * Get user's primary team and role
 * @param {Object} user - User object with teams array
 * @returns {Object} - { team: string, role: string }
 */
export const getUserPrimaryTeamRole = (user) => {
  if (!user?.teams || user.teams.length === 0) {
    return { team: null, role: null };
  }

  // Find management team first (highest priority)
  const managementTeam = user.teams.find(
    (t) => t.team?.type?.toLowerCase() === "management",
  );
  if (managementTeam) {
    return {
      team: "management",
      role: managementTeam.role || "member",
    };
  }

  // Otherwise, use the first team
  const primaryTeam = user.teams[0];
  return {
    team: primaryTeam.team?.type?.toLowerCase() || null,
    role: primaryTeam.role || "member",
  };
};

/**
 * Check if user has access to a specific route
 * @param {string} route - Route to check
 * @param {Object} user - User object
 * @returns {boolean}
 */
export const hasRouteAccess = (route, user) => {
  const { team, role } = getUserPrimaryTeamRole(user);

  if (!team || !role) return false;

  const permissions = TEAM_PERMISSIONS[team]?.[role];
  if (!permissions) return false;

  // Management has access to all routes
  if (permissions.allowedRoutes === "*") return true;

  // Check if the route is in allowed routes
  return permissions.allowedRoutes.some((allowedRoute) => {
    // Handle dynamic routes with parameters (e.g., /leads/:id)
    if (allowedRoute.includes(":")) {
      const routePattern = allowedRoute.replace(/:[^/]+/g, "[^/]+");
      const regex = new RegExp(`^${routePattern}$`);
      return regex.test(route);
    }
    // Handle regular routes
    return route.startsWith(allowedRoute);
  });
};

/**
 * Get filtered navigation items based on user permissions
 * @param {Array} navSections - All navigation sections
 * @param {Object} user - User object
 * @returns {Array} - Filtered navigation sections
 */
export const getFilteredNavigation = (navSections, user) => {
  const { team, role } = getUserPrimaryTeamRole(user);

  if (!team || !role) return [];

  const permissions = TEAM_PERMISSIONS[team]?.[role];
  if (!permissions) return [];

  // Management gets everything
  if (permissions.navigationItems === "*") return navSections;

  // Filter sections and items based on permissions
  return navSections
    .map((section) => ({
      ...section,
      items: section.items.filter((item) =>
        permissions.navigationItems.includes(item.label),
      ),
    }))
    .filter((section) => section.items.length > 0);
};

/**
 * Check if user should see settings page
 * @param {Object} user - User object
 * @returns {boolean}
 */
export const canAccessSettings = (user) => {
  const { team } = getUserPrimaryTeamRole(user);
  return team === "management";
};

/**
 * Get redirect path for unauthorized access
 * @param {Object} user - User object
 * @returns {string}
 */
export const getDefaultRedirectPath = (user) => {
  const { team, role } = getUserPrimaryTeamRole(user);

  if (!team || !role) return "/dashboard";

  const permissions = TEAM_PERMISSIONS[team]?.[role];
  if (!permissions || !permissions.allowedRoutes) return "/dashboard";

  if (permissions.allowedRoutes === "*") return "/dashboard";

  // Return first allowed route after dashboard
  return (
    permissions.allowedRoutes[1] || permissions.allowedRoutes[0] || "/dashboard"
  );
};
